import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StudyReportLogisticsCommentService } from '../../../services/study-report/study-report-logistics-comment.service';
import { StudyReportLogisticsComment } from '../../../model/study-report/study-report-logistics-comment';
import { StatusPhotography } from '../../../model/status-photography';
import { MedicalServiceService } from '../../../services/medical-service.service';


export interface StatusPhotographyDialogRequest {
  medicalAppointmentId: number;
  statusPhotographyName: string;
}
 
 
@Component({
  selector: 'app-status-photography-dialog',
  templateUrl: './status-photography-dialog.compnent.html',
  styleUrls: ['./status-photography-dialog.compnent.css']
})
export class StatusPhotographyDialogComponent implements OnInit {

  form: FormGroup;
  statusPhotographies: StatusPhotography[] = [];
  saving:  boolean = false;

  constructor(
    public dialogRef: MatDialogRef<StatusPhotographyDialogComponent>,
     private formBuilder: FormBuilder,
     private medicalServiceService: MedicalServiceService,
     private service: StudyReportLogisticsCommentService, 
     @Inject(MAT_DIALOG_DATA) public request: StatusPhotographyDialogRequest) {
      this.form = this.formBuilder.group({
        statusPhotography: [ null, Validators.required ]
      });
    }

  get f() { return this.form.controls; }

  async ngOnInit() {
    this.statusPhotographies = await this.medicalServiceService.getStatusPhotography();
    this.form.patchValue({ 
      statusPhotography: this.statusPhotographies.find(x => x.Name === this.request.statusPhotographyName)
    })
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {  
    if ( this.form.valid ) {
        this.saving = true; 
        await this.medicalServiceService
            .statusPhotographyUpdate(
                    this.request.medicalAppointmentId,
                    this.f.statusPhotography.value.Id );
        this.saving = false;
        this.dialogRef.close( 
           this.f.statusPhotography.value
         );
    }
  }
}
